module.exports = __webpack_public_path__ + "media/images/kinetix_favicon1021x1021-0c7592ceb8a6d98c6b0c639f1c2038e2.png";